import { createFileRoute } from '@tanstack/react-router'
import { MedicalsTabPage } from '~/features/dashboard/pages/medicals'
import { medicalsAllergiesQueryOptions, medicalsConditionsQueryOptions, activeMedicationsQueryOptions, medicalsMedicationsRefillHistoryQueryOptions, medicalsMedicationsRefillProcessingQueryOptions } from '~/features/dashboard/pages/medicals/api/queries'


export const Route = createFileRoute(
  '/(dashboard)/dashboard/weight-loss/medicals/$tab',
)({
  beforeLoad: async ({ params }) => {
    const type = params.tab;
    if (type !== "medications" && type !== "conditions") {
      throw new Error("Invalid type parameter. Must be either 'medications' or 'conditions'");
    }
  },
  loader: ({ context }) => {
    context.queryClient.ensureQueryData(medicalsAllergiesQueryOptions("weight_loss"))
    context.queryClient.ensureQueryData(medicalsConditionsQueryOptions("weight_loss"))
    context.queryClient.ensureQueryData(activeMedicationsQueryOptions())
    context.queryClient.ensureQueryData(medicalsMedicationsRefillHistoryQueryOptions())
    context.queryClient.ensureQueryData(medicalsMedicationsRefillProcessingQueryOptions())
  },
  component: () => <MedicalsTabPage />,
})


